import { applyMiddleware, compose, createStore } from 'redux'
import promiseMiddleware from 'redux-promise-middleware'
import thunk from 'redux-thunk'
import reducer from './reducer'

let composeEnhancers = compose

declare global {
    interface Window {
        __REDUX_DEVTOOLS_EXTENSION_COMPOSE__?: any
    }
}

// @ts-ignore
if (typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ && !PRODUCTION) {
    // if we're running in a browser and have the redux dev tools installed, use them.
    composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ as typeof compose
}

const tidewaysApiClientMiddleware = store => next => async action => {
    if (typeof action.payload === 'function') {
        const state = await store.getState()
        const organizationName = state.tidewaysContext.organization?.name
        const applicationName = state.tidewaysContext.application?.name

        const fetchForApplication = (url, init) => {
            if (!organizationName || !applicationName) {
                throw new Error('fetchForApplication called without organization or application context set.')
            }

            return fetchSimple(`/o/${organizationName}/${applicationName}${url}`, init)
        }

        const fetchSimple = (url, init) =>
            fetch(url, {
                ...init,
                credentials: 'same-origin',
                headers: init ? { 'X-Requested-With': 'XMLHttpRequest', ...init.headers } : { 'X-Requested-With': 'XMLHttpRequest' },
            }).then(response => {
                if (!response.ok) {
                    // out of retention resources, i.e. traces
                    if (response.status === 410) {
                        window.location.reload()
                    }

                    return response.json().then(
                        data => {
                            if ('errorMessage' in data) {
                                throw new Error(data.errorMessage)
                            }
                            if ('msg' in data) {
                                throw new Error(data.msg)
                            }

                            throw new Error('unknown error')
                        },
                        () => {
                            throw new Error('unknown error')
                        },
                    )
                }

                return response.json()
            })

        return next({
            ...action,
            payload: action.payload({ fetchForApplication, fetchSimple, getState: store.getState }),
        })
    }
    return next(action)
}

export default createStore(
    reducer,
    composeEnhancers(applyMiddleware(thunk), applyMiddleware(tidewaysApiClientMiddleware), applyMiddleware(promiseMiddleware())),
)
